module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "helveticaneuecyr-bold.de7ef001.ttf";